import { render, staticRenderFns } from "./SpecificKeyword.vue?vue&type=template&id=3912de5c&scoped=true"
import script from "./SpecificKeyword.vue?vue&type=script&lang=js"
export * from "./SpecificKeyword.vue?vue&type=script&lang=js"
import style0 from "./SpecificKeyword.vue?vue&type=style&index=0&id=3912de5c&prod&scoped=true&lang=css"
import style1 from "./SpecificKeyword.vue?vue&type=style&index=1&id=3912de5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3912de5c",
  null
  
)

export default component.exports